<template>
  <span>
    <slot />
    <span class="error--text"> *</span>
  </span>
</template>

<script>
export default {};
</script>
